export default __webpack_public_path__ + "static/media/02.0dfa77e7.jpg";